import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: "#FAFAFA",
      display: "flex",
      flexWrap: "wrap",
    },
    textFieldLeft: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      maxWidth: 80,
    },
  })
);
